import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: document.getElementById('sietovaKalkulacka').getAttribute("jazyk"),//'cz',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    // language resources
    resources: {
      sk: {
        translation: {
            hlNad: "Sieťová IP/CIDR kalkulačka",
            divPop: "Táto IPv4 sieťová kalkulačka podporujúca CIDR a VLSM vám ľahko zistí rozsahy IP adries podľa zvolenej schémy, sieťovú bránu ako aj údaje, ktoré je treba zadať jednodlivým hostom ako napr. sieťová maska a žolík v dekatickom ako aj v binárnom tvare.",
            divPriklPodlTr: "Príklady IP adries podľa (classfull) triednej schémy",
            btnTrA: "trieda A",            
            btnTrB: "trieda B",
            btnTrC: "trieda C",
            btnTrD: "trieda D",
            btnTrE: "trieda E",
            divRiadCen: "Zadajte IP adresu a dĺžku sieťového prefixu",
            btnDecHosts: "znížiť počet hostov",
            btnIncHosts: "zvýšiť počet hostov",
            h2VypSM: "Výpočet sieťovej masky",
            btnSmWcDec: "dekadický tvar",
            btnSmWcBin: "binárny tvar",
            h2VypocetRozsahovSiete: "Výpočet IP rozsahov siete",
            h2VypocetMnozstvaIpAdries: "Výpočet množstva IP adries",
            sm: "Sieťová maska",
            wc: "Wildcard",
            nwid: "Adresa (ID) siete",
            rozsah: "Rozsah IP",
            lbc: "Lokálny broadcast",
            gw: "Odporúčaná adresa brány",
            celkovoIp: "Celkovo IP adries",
            pouzitelnychIp: "Použiteľných IP adries",
            pouzitelnychWoGw: "Použiteľných IP adries bez brány",
            percentIpKolaca: "Percent z celkového počtu IPv4 adries",
        }
      },
      cz: {
        translation: {
            hlNad: "Síťová IP/CIDR kalkulačka",
            divPop: "Tato IPv4 síťová kalkulačka podporující CIDR a VLSM vám snadno zjistí rozsahy IP adres podle zvoleného schématu, síťovou bránu i údaje, které je třeba zadat jednodlivým hostům jako např. síťová maska a žolík v dekatickém i binárním tvaru.",
            divPriklPodlTr: "Příklady IP adres podle (classfull) třídního schématu",
            btnTrA: "třída A",
            btnTrB: "třída B",
            btnTrC: "třída C",
            btnTrD: "třída D",
            btnTrE: "třída E",
            divRiadCen: "Zadejte IP adresu a délku síťového prefixu",
            btnDecHosts: "snížit počet hostů",
            btnIncHosts: "zvýšit počet hostů",
            h2VypSM: "Výpočet síťové masky",
            btnSmWcDec: "dekadický tvar",
            btnSmWcBin: "binární tvar",
            h2VypocetRozsahovSiete: "Výpočet IP rozsahů sítě",
            h2VypocetMnozstvaIpAdries: "Výpočet množství IP adres",
            sm: "Síťová maska",
            wc: "Wildcard",
            nwid: "Adresa (ID) sítě",
            rozsah: "Rozsah IP",
            lbc: "Lokální broadcast",
            gw: "Doporučená adresa brány",
            celkovoIp: "Celkově IP adres",
            pouzitelnychIp: "Použitelných IP adres",
            pouzitelnychWoGw: "Použitelných IP adres bez brány",
            percentIpKolaca: "Procent z celkového počtu IPv4 adres",
        }
      },
      pl: {
        translation: {
            hlNad: "Kalkulator IP sieci/CIDR",
            divPop: "Ten kalkulator sieci IPv4 obsługujący CIDR i VLSM z łatwością wykryje zakresy adresów IP zgodnie z wybranym schematem, bramę sieciową oraz dane, które musi wprowadzić pojedynczy gość, takie jak maska ​​​​sieci i joker w zarówno w postaci dekatycznej, jak i binarnej.",
            divPriklPodlTr: "Przykłady adresów IP według (pełnego) schematu klas",
            btnTrA: "klasa A",
            btnTrB: "klasa B",
            btnTrC: "klasa C",
            btnTrD: "klasa D",
            btnTrE: "Klasa E",
            divRiadCen: "Wprowadź adres IP i długość prefiksu sieci",
            btnDecHosts: "zmniejsz liczbę hostów",
            btnIncHosts: "zwiększ liczbę hostów",
            h2VypSM: "Obliczanie maski sieci",
            btnSmWcDec: "forma dziesiętna",
            btnSmWcBin: "forma binarna",
            h2VypocetRozsahovSiete: "Obliczanie zasięgów sieci IP",
            h2VypocetMnozstvaIpAdries: "Obliczanie liczby adresów IP",
            sm: "Maska sieci",
            wc: "Wildcard",
            nwid: "Adres sieciowy (ID)",
            rozsah: "Zakres IP",
            lbc: "Lokalna broadcast",
            gw: "Zalecany adres bramy",
            celkovoIp: "Całkowita liczba adresów IP",
            pouzitelnychIp: "Użyteczne adresy IP",
            pouzitelnychWoGw: "Użyteczne adresy IP bez bramy",
            percentIpKolaca: "Procent całkowitej liczby adresów IPv4",
        }
      },
      hu: {
        translation: {
            hlNad: "Hálózati IP/CIDR kalkulátor",
            divPop: "Ez a CIDR-t és VLSM-t támogató IPv4-es hálózati számológép könnyen megtudja az IP-címtartományokat a választott séma szerint, a hálózati átjárót, valamint azokat az adatokat, amelyeket az egyetlen vendégnek meg kell adnia, például a hálózati maszkot és a jokert. dekatikus és bináris formában egyaránt.",
            divPriklPodlTr: "Példák IP-címekre (osztályteljes) osztályséma szerint",
            btnTrA: "A osztály",
            btnTrB: "B osztály",
            btnTrC: "C osztály",
            btnTrD: "D osztály",
            btnTrE: "E osztály",
            divRiadCen: "Írja be az IP-címet és a hálózati előtag hosszát",
            btnDecHosts: "csökkenti a gazdagépek számát",
            btnIncHosts: "növelje a gazdagépek számát",
            h2VypSM: "Hálózati maszk számítása",
            btnSmWcDec: "tizedes forma",
            btnSmWcBin: "bináris forma",
            h2VypocetMnozstvaIpAdries: "IP-címek számának kiszámítása",
            sm: "hálózati maszk",
            wc: "Wildcard",
            nwid: "Hálózati cím (ID)",
            rozsah: "IP Range",
            lbc: "Helyi broadcast",
            gw: "Ajánlott átjáró cím",
            celkovoIp: "Összes IP-cím",
            pouzitelnychIp: "Használható IP-címek",
            pouzitelnychWoGw: "Használható IP-címek átjáró nélkül",
            percentIpKolaca: "Az IPv4-címek teljes számának százaléka",
        }
      },      
      en: {
        translation: {
            hlNad: "Network IP/CIDR Calculator",
            divPop: "This IPv4 network calculator supporting CIDR and VLSM will easily find out the IP address ranges according to the chosen scheme, the network gateway as well as the data that needs to be entered by the single guest such as the netmask and the joker in both decatic and binary form.",
            divPriklPodlTr: "Examples of IP addresses according to (classfull) class scheme",
            btnTrA: "class A",
            btnTrB: "class B",
            btnTrC: "class C",
            btnTrD: "class D",
            btnTrE: "Class E",
            divRiadCen: "Enter IP address and network prefix length",
            btnDecHosts: "decrease number of hosts",
            btnIncHosts: "increase number of hosts",
            h2VypSM: "Netmask Calculation",
            btnSmWcDec: "decadal form",
            btnSmWcBin: "binary form",
            h2VypocetMnozstvaIpAdries: "Calculation of the number of IP addresses",
            sm: "Netmask",
            wc: "Wildcard",
            nwid: "Address (ID) of the network",
            rozsah: "IP Range",
            lbc: "Local broadcast",
            gw: "Recommended gateway address",
            celkovoIp: "Total IP address",
            pouzitelnychIp: "Usable IP addresses",
            pouzitelnychWoGw: "Usable IP addresses without a gateway",
            percentIpKolaca: "Percent of the total number of IPv4 addresses",
        }
      },
      de: {
        translation: {
            hlNad: "Netzwerk-IP/CIDR-Rechner",
            divPop: "Dieser IPv4-Netzwerkrechner, der CIDR und VLSM unterstützt, findet problemlos die IP-Adressbereiche gemäß dem gewählten Schema, das Netzwerk-Gateway sowie die Daten, die vom einzelnen Gast eingegeben werden müssen, wie die Netzmaske und den Joker, heraus sowohl dekatische als auch binäre Form.",
            divPriklPodlTr: "Beispiele für IP-Adressen nach (classfull) Klassenschema",
            btnTrA: "Klasse A",
            btnTrB: "Klasse B",
            btnTrC: "Klasse C",
            btnTrD: "Klasse D",
            btnTrE: "Klasse E",
            divRiadCen: "Geben Sie die IP-Adresse und die Länge des Netzwerkpräfixes ein",
            btnDecHosts: "Anzahl der Hosts verringern",
            btnIncHosts: "Anzahl der Hosts erhöhen",
            h2VypSM: "Netzmaskenberechnung",
            btnSmWcDec: "Dekadenform",
            btnSmWcBin: "Binärform",
            h2VypocetMnozstvaIpAdries: "Berechnung der Anzahl IP-Adressen",
            sm: "Netzmaske",
            wc: "Wildcard",
            nwid: "Netzwerkadresse (ID)",
            rozsah: "IP-Bereich",
            lbc: "Lokale broadcast",
            gw: "Empfohlene Gateway-Adresse",
            celkovoIp: "IP-Adressen insgesamt",
            pouzitelnychIp: "Nutzbare IP-Adressen",
            pouzitelnychWoGw: "Nutzbare IP-Adressen ohne Gateway",
            percentIpKolaca: "Prozent der Gesamtzahl der IPv4-Adressen",
        }
      },
      es: {
        translation: {
            hlNad: "Calculadora de red IP/CIDR",
            divPop: "Esta calculadora de red IPv4 compatible con CIDR y VLSM encontrará fácilmente los rangos de direcciones IP de acuerdo con el esquema elegido, la puerta de enlace de la red y los datos que debe ingresar el invitado único, como la máscara de red y el comodín en forma decática y binaria.",
            divPriklPodlTr: "Ejemplos de direcciones IP según el esquema de clase (con clase)",
            btnTrA: "clase A",
            btnTrB: "clase B",
            btnTrC: "clase C",
            btnTrD: "clase D",
            btnTrE: "Clase E",
            divRiadCen: "Ingrese la dirección IP y la longitud del prefijo de red",
            btnDecHosts: "disminuir el número de hosts",
            btnIncHosts: "aumentar el número de hosts",
            h2VypSM: "Cálculo de máscara de red",
            btnSmWcDec: "forma decadal",
            btnSmWcBin: "forma binaria",
            h2VypocetMnozstvaIpAdries: "Cálculo del número de direcciones IP",
            sm: "Máscara de red",
            wc: "Wildcard",
            nwid: "Dirección de red (ID)",
            rozsah: "Rango IP",
            lbc: "Local broadcast",
            gw: "Dirección de puerta de enlace recomendada",
            celkovoIp: "Total de direcciones IP",
            pouzitelnychIp: "Direcciones IP utilizables",
            pouzitelnychWoGw: "Direcciones IP utilizables sin puerta de enlace",
            percentIpKolaca: "Porcentaje del número total de direcciones IPv4",
        }
      },
      portugal: {
        translation: {
            hlNad: "Calculadora de IP/CIDR de rede",
            divPop: "Esta calculadora de rede IPv4 com suporte a CIDR e VLSM descobrirá facilmente os intervalos de endereços IP de acordo com o esquema escolhido, o gateway de rede, bem como os dados que precisam ser inseridos pelo único convidado, como a máscara de rede e o curinga em forma decática e binária.",
            divPriklPodlTr: "Exemplos de endereços IP de acordo com o esquema de classe (classfull)",
            btnTrA: "classe A",
            btnTrB: "classe B",
            btnTrC: "classe C",
            btnTrD: "classe D",
            btnTrE: "Classe E",
            divRiadCen: "Digite o endereço IP e o tamanho do prefixo da rede",
            btnDecHosts: "diminuir número de hosts",
            btnIncHosts: "aumentar número de hosts",
            h2VypSM: "Cálculo da máscara de rede",
            btnSmWcDec: "forma decadal",
            btnSmWcBin: "forma binária",
            h2VypocetMnozstvaIpAdries: "Cálculo do número de endereços IP",
            sm: "Máscara de rede",
            wc: "Wildcard",
            nwid: "Endereço de rede (ID)",
            rozsah: "Intervalo de IP",
            lbc: "Local broadcast",
            gw: "Endereço de gateway recomendado",
            celkovoIp: "Total de endereços IP",
            pouzitelnychIp: "Endereços IP utilizáveis",
            pouzitelnychWoGw: "Endereços IP utilizáveis ​​sem gateway",
            percentIpKolaca: "Porcentagem do número total de endereços IPv4",
        }
      },
      it: {
        translation: {
            hlNad: "Calcolatrice IP/CIDR di rete",
            divPop: "Questo calcolatore di rete IPv4 che supporta CIDR e VLSM troverà facilmente gli intervalli di indirizzi IP in base allo schema scelto, il gateway di rete nonché i dati che devono essere inseriti dal singolo ospite come la netmask e il jolly in sia in forma decatica che binaria.",
            divPriklPodlTr: "Esempi di indirizzi IP secondo lo schema di classe (classfull)",
            btnTrA: "classe A",
            btnTrB: "classe B",
            btnTrC: "classe C",
            btnTrD: "classe D",
            btnTrE: "Classe E",
            divRiadCen: "Inserisci l'indirizzo IP e la lunghezza del prefisso di rete",
            btnDecHosts: "diminuisce il numero di host",
            btnIncHosts: "aumenta il numero di host",
            h2VypSM: "Calcolo maschera di rete",
            btnSmWcDec: "forma decennale",
            btnSmWcBin: "forma binaria",
            h2VypocetRozsahovSiete: "Calcolo degli intervalli di rete IP",
            h2VypocetMnozstvaIpAdries: "Calcolo del numero di indirizzi IP",
            sm: "Maschera di rete",
            wc: "Wildcard",
            nwid: "Indirizzo di rete (ID)",
            rozsah: "Intervallo IP",
            lbc: "Local broadcast",
            gw: "Indirizzo gateway consigliato",
            celkovoIp: "Indirizzi IP totali",
            pouzitelnychIp: "Indirizzi IP utilizzabili",
            pouzitelnychWoGw: "Indirizzi IP utilizzabili senza gateway",
            percentIpKolaca: "Percentuale del numero totale di indirizzi IPv4",
        }
      },     
      ch: {        // zjednodusena cinstina
        translation: {
            hlNad: "网络 IP/CIDR 计算器",
            divPop: "这款支持 CIDR 和 VLSM 的 IPv4 网络计算器将根据所选方案轻松找出 IP 地址范围，网络网关以及单个访客需要输入的数据，例如网络掩码和 joker decatic 和二进制形式。",
            divPriklPodlTr: "根据（全类）类方案的 IP 地址示例",
            btnTrA: "A 类",
            btnTrB: "B 类",
            btnTrC: "C 类",
            btnTrD: "D 级",
            btnTrE: "E 类",
            divRiadCen: "输入 IP 地址和网络前缀长度",
            btnDecHosts: "减少主机数量",
            btnIncHosts: "增加主机数量",
            h2VypSM: "网络掩码计算",
            btnSmWcDec: "十年形式",
            btnSmWcBin: "二进制形式",
            h2VypocetRozsahovSiete: "计算IP网络范围",
            h2VypocetMnozstvaIpAdries:"计算IP地址数",
            sm: "网络掩码",
            wc: "小丑（通配符）",
            nwid: "网络地址(ID)",
            rozsah: "IP范围",
            lbc: "本地 broadcast",
            gw: "推荐网关地址",
            celkovoIp: "IP 地址总数",
            pouzitelnychIp: "可用IP地址",
            pouzitelnychWoGw: "没有网关的可用 IP 地址",
            percentIpKolaca: "占 IPv4 地址总数的百分比",
        }
      },
      ru: {
        translation: {
            hlNad: "Калькулятор сетевого IP/CIDR",
            divPop: "Этот сетевой калькулятор IPv4 с поддержкой CIDR и VLSM легко определит диапазоны IP-адресов в соответствии с выбранной схемой, сетевым шлюзом, а также данные, которые необходимо ввести одному гостю, такие как сетевая маска и джокер в как в десятичной, так и в бинарной форме.",
            divPriklPodlTr: "Примеры IP-адресов согласно (классовой) схеме классов",
            бтнТрА: "класс А",
            btnTrB: "класс B",
            btnTrC: "класс C",
            бтнТРД: "класс D",
            btnTrE: "Класс E",
            divRiadCen: "Введите IP-адрес и длину сетевого префикса",
            btnDecHosts: "уменьшить количество хостов",
            btnIncHosts: "увеличить количество хостов",
            h2VypSM: "Расчет сетевой маски",
            btnSmWcDec: "десятичная форма",
            btnSmWcBin: "бинарная форма",
            h2VypocetRozsahovSiete: "Расчет диапазонов IP-сетей",
            h2VypocetMnozstvaIpAdries: "Расчет количества IP-адресов",
            sm: "Маска сети",
            wc: "Wildcard",
            nwid: "Сетевой адрес (ID)",
            rozsah: "Диапазон IP",
            lbc: "Местный broadcast",
            gw: "Рекомендуемый адрес шлюза",
            celkovoIp: "Всего IP-адресов",
            pouzitelnychIp: "Используемые IP-адреса",
            pouzitelnychWoGw: "Используемые IP-адреса без шлюза",
            percentIpKolaca: "Процент от общего количества адресов IPv4",
        }
      },
      ua: {
        translation: {
             hlNad: "Калькулятор IP/CIDR мережі",
             divPop: "Цей мережевий калькулятор IPv4, що підтримує CIDR і VLSM, легко знайде діапазони IP-адрес відповідно до вибраної схеми, мережевий шлюз, а також дані, які потрібно ввести окремому гостю, наприклад маску мережі та джокера в як десяткова, так і двійкова форма.",
             divPriklPodlTr: "Приклади IP-адрес відповідно до (повної) схеми класів",
             btnTrA: "клас A",
             btnTrB: "клас B",
             btnTrC: "клас C",
             btnTrD: "клас D",
             btnTrE: "Клас E",
             divRiadCen: "Введіть IP-адресу та довжину мережевого префікса",
             btnDecHosts: "зменшити кількість хостів",
             btnIncHosts: "збільшити кількість хостів",
             h2VypSM: "Обчислення маски мережі",
             btnSmWcDec: "десяткова форма",
             btnSmWcBin: "двійкова форма",
             h2VypocetRozsahovSiete: "Розрахунок діапазонів IP-мереж",
             h2VypocetMnozstvaIpAdries: "Обчислення кількості IP-адрес",
             sm: "Маска мережі",
             wc: "Wildcard",
             nwid: "Мережева адреса (ID)",
             rozsah: "Діапазон IP",
             lbc: "Місцевий broadcast",
             gw: "Рекомендована адреса шлюзу",
             celkovoIp: "Загальна кількість IP-адрес",
             pouzitelnychIp: "Використовувані IP-адреси",
             pouzitelnychWoGw: "Використовувані IP-адреси без шлюзу",
             percentIpKolaca: "Відсоток від загальної кількості адрес IPv4",
        }
      },
      jp: {
        translation: {
            hlNad: "ネットワーク IP/CIDR 計算機",
            divPop: "CIDR と VLSM をサポートするこの IPv4 ネットワーク計算機は、選択したスキーム、ネットワーク ゲートウェイ、およびネットマスクやジョーカーなどの単一のゲストが入力する必要があるデータに従って、IP アドレス範囲を簡単に見つけます。デカティック形式とバイナリ形式の両方。",
            divPriklPodlTr: "(classfull) クラス方式による IP アドレスの例",
            btnTrA: "クラス A",
            btnTrB: "クラス B",
            btnTrC: "クラス C",
            btnTrD: "クラス D",
            btnTrE: "クラス E",
            divRiadCen: "IPアドレスとネットワークプレフィックス長を入力してください",
            btnDecHosts: "ホスト数を減らす",
            btnIncHosts: "ホスト数を増やす",
            h2VypSM: "ネットマスク計算",
            btnSmWcDec: "十年形",
            btnSmWcBin: "バイナリ形式",
            h2VypocetRozsahovSiete: "ネットワーク IP 範囲の計算",
            h2VypocetMnozstvaIpAdries: "「IPアドレス数の計算」",
            sm: "ネットマスク",
            wc: "ワイルドカード",
            nwid: "ネットワークアドレス(ID)",
            rozsah: "IP 範囲",
            lbc: "ローカル broadcast",
            gw: "推奨ゲートウェイアドレス",
            celkovoIp: "合計 IP アドレス",
            pouzitelnychIp: "使用可能なIPアドレス",
            pouzitelnychWoGw: "ゲートウェイなしで利用可能なIPアドレス",
            percentIpKolaca: "IPv4 アドレスの総数の割合",
        }
      },
      hindi: {
        translation: {
            hlNad: "नेटवर्क आईपी/सीआईडीआर कैलक्यूलेटर",
            divPop: "सीआईडीआर और वीएलएसएम का समर्थन करने वाला यह आईपीवी4 नेटवर्क कैलकुलेटर आसानी से चुने गए योजना के अनुसार आईपी एड्रेस रेंज, नेटवर्क गेटवे के साथ-साथ नेटमास्क और जोकर जैसे एकल अतिथि द्वारा दर्ज किए जाने वाले डेटा का पता लगाएगा। दोनों निर्णायक और द्विआधारी रूप।",
            divPriklPodlTr: "(क्लासफुल) क्लास स्कीम के अनुसार आईपी एड्रेस के उदाहरण",
            btnTrA: "कक्षा ए",
            btnTrB: "कक्षा बी",
            btnTrC: "कक्षा सी",
            btnTrD: "कक्षा डी",
            btnTrE: "कक्षा ई",
            divRiadCen: "आईपी पता और नेटवर्क उपसर्ग लंबाई दर्ज करें",
            btnDecHosts: "मेजबानों की संख्या कम करें",
            btnIncHosts: "मेजबानों की संख्या में वृद्धि",
            h2VypSM: "नेटमास्क गणना",
            btnSmWcDec: "डिकैडल फॉर्म",
            btnSmWcBin: "बाइनरी फॉर्म",
            h2VypocetRozsahovSiete: "IP नेटवर्क रेंज की गणना",
            h2VypocetMnozstvaIpAdries: "IP पतों की संख्या की गणना",
            sm: "नेटमास्क",
            wc: "वाइल्डकार्ड",
            nwid: "नेटवर्क पता (आईडी)",
            rozsah: "आईपी रेंज",
            lbc: "स्थानीय broadcast",
            gw: "अनुशंसित प्रवेश द्वार का पता",
            celkovoIp: "कुल आईपी पते",
            pouzitelnychIp: "प्रयोग करने योग्य आईपी पते",
            pouzitelnychWoGw: "गेटवे के बिना प्रयोग करने योग्य आईपी पते",
            percentIpKolaca: "IPv4 पतों की कुल संख्या का प्रतिशत",
        }
      },
      bengali: {
        translation: {
            hlNad: "নেটওয়ার্ক আইপি/সিআইডিআর ক্যালকুলেটর",
            divPop: "সিআইডিআর এবং ভিএলএসএম সমর্থনকারী এই IPv4 নেটওয়ার্ক ক্যালকুলেটরটি সহজেই নির্বাচিত স্কিম, নেটওয়ার্ক গেটওয়ে এবং সেইসাথে নেটমাস্ক এবং জোকারের মতো একক অতিথির দ্বারা প্রবেশ করানো প্রয়োজন অনুযায়ী আইপি ঠিকানার রেঞ্জগুলি খুঁজে বের করবে৷ উভয় ডেক্যাটিক এবং বাইনারি ফর্ম।",
            divPriklPodlTr: "(classfull) ক্লাস স্কিম অনুযায়ী IP ঠিকানাগুলির উদাহরণ",
            btnTrA: "ক্লাস এ",
            btnTrB: "ক্লাস B",
            btnTrC: "ক্লাস সি",
            btnTrD: "ক্লাস ডি",
            btnTrE: "ক্লাস ই",
            divRiadCen: "IP ঠিকানা এবং নেটওয়ার্ক উপসর্গের দৈর্ঘ্য লিখুন",
            btnDecHosts: "হোস্টের সংখ্যা হ্রাস করুন",
            btnIncHosts: "হোস্টের সংখ্যা বাড়ান",
            h2VypSM: "নেটমাস্ক গণনা",
            btnSmWcDec: "দশক ফর্ম",
            btnSmWcBin: "বাইনারী ফর্ম",
            h2VypocetRozsahovSiete: "আইপি নেটওয়ার্ক রেঞ্জের গণনা",
            h2VypocetMnozstvaIpAdries: "IP ঠিকানাগুলির সংখ্যার গণনা",
            sm: "নেটমাস্ক",
            wc: "জোকার ",
            nwid: "আইডি",
            rozsah: "আইপি রেঞ্জ",
            lbc: "স্থানীয় broadcast",
            gw: "প্রস্তাবিত গেটওয়ে ঠিকানা",
            celkovoIp: "মোট আইপি ঠিকানা",
            pouzitelnychIp: "ব্যবহারযোগ্য আইপি ঠিকানা",
            pouzitelnychWoGw: "একটি গেটওয়ে ছাড়া আইপি ঠিকানা ব্যবহারযোগ্য",
            percentIpKolaca: "IPv4 ঠিকানার মোট সংখ্যার শতাংশ",
        }
      },
      marathi: {
        translation: {
            hlNad: "नेटवर्क IP/CIDR कॅल्क्युलेटर",
            divPop: "सीआयडीआर आणि व्हीएलएसएमला समर्थन देणारे हे IPv4 नेटवर्क कॅल्क्युलेटर निवडलेल्या योजनेनुसार IP पत्ता श्रेणी, नेटवर्क गेटवे तसेच नेटमास्क आणि जोकर सारख्या सिंगल अतिथीद्वारे प्रविष्ट करणे आवश्यक असलेला डेटा सहजपणे शोधू शकेल. दोन्ही डेकॅटिक आणि बायनरी फॉर्म.",
            divPriklPodlTr: "(क्लासफुल) वर्ग योजनेनुसार IP पत्त्यांचे उदाहरण",
            btnTrA: "वर्ग अ",
            btnTrB: "वर्ग बी",
            btnTrC: "क्लास सी",
            btnTrD: "वर्ग डी",
            btnTrE: "वर्ग ई",
            divRiadCen: "IP पत्ता आणि नेटवर्क उपसर्ग लांबी प्रविष्ट करा",
            btnDecHosts: "यजमानांची संख्या कमी करा",
            btnIncHosts: "यजमानांची संख्या वाढवा",
            h2VypSM: "नेटमास्क गणना",
            btnSmWcDec: "दशकीय स्वरूप",
            btnSmWcBin: "बायनरी फॉर्म",
            h2VypocetRozsahovSiete: "IP नेटवर्क श्रेणींची गणना",
            h2VypocetMnozstvaIpAdries: "IP पत्त्यांच्या संख्येची गणना",
            sm: "नेटमास्क",
            wc: "वाइल्डकार्ड",
            nwid: "नेटवर्क पत्ता (आयडी)",
            rozsah: "IP श्रेणी",
            lbc: "स्थानिक broadcast",
            gw: "शिफारस केलेला गेटवे पत्ता",
            celkovoIp: "एकूण IP पत्ते",
            pouzitelnychIp: "वापरण्यायोग्य IP पत्ते",
            pouzitelnychWoGw: "गेटवेशिवाय IP पत्ते वापरता येण्याजोगे",
            percentIpKolaca: "IPv4 पत्त्यांच्या एकूण संख्येची टक्केवारी",
        }
      },  
      viet: {
        translation: {
            hlNad: "Máy tính IP/CIDR mạng",
            divPop: "Máy tính mạng IPv4 hỗ trợ CIDR và ​​VLSM này sẽ dễ dàng tìm ra dải địa chỉ IP theo sơ đồ đã chọn, cổng mạng cũng như dữ liệu cần được nhập bởi một khách như mặt nạ mạng và người pha trò trong cả dạng decatic và nhị phân.",
            divPriklPodlTr: "Ví dụ về địa chỉ IP theo sơ đồ lớp (đầy đủ)",
            btnTrA: "lớp A",
            btnTrB: "lớp B",
            btnTrC: "lớp C",
            btnTrD: "lớp D",
            btnTrE: "Lớp E",
            divRiadCen: "Nhập địa chỉ IP và độ dài tiền tố mạng",
            btnDecHosts: "giảm số lượng máy chủ",
            btnIncHosts: "tăng số lượng máy chủ",
            h2VypSM: "Tính toán mặt nạ mạng",
            btnSmWcDec: "dạng thập phân",
            btnSmWcBin: "dạng nhị phân",
            h2VypocetRozsahovSiete: "Tính toán phạm vi mạng IP",
            h2VypocetMnozstvaIpAdries: "Tính toán số lượng địa chỉ IP",
            sm: "Mặt nạ mạng",
            wc: "Wildcard",
            nwid: "Địa chỉ mạng (ID)",
            rozsah: "Phạm vi IP",
            lbc: "Cục bộ broadcast",
            gw: "Địa chỉ cổng được đề xuất",
            celkovoIp: "Tổng số địa chỉ IP",
            pouzitelnychIp: "Địa chỉ IP có thể sử dụng",
            pouzitelnychWoGw: "Địa chỉ IP khả dụng không có cổng",
            percentIpKolaca: "Phần trăm trên tổng số địa chỉ IPv4",
        }
      },     
    fr: {
        translation: {
            hlNad : "Calculateur IP/CIDR réseau",
            divPop : "Ce calculateur de réseau IPv4 prenant en charge CIDR et VLSM trouvera facilement les plages d'adresses IP en fonction du schéma choisi, la passerelle réseau ainsi que les données qui doivent être saisies par l'invité unique telles que le masque de réseau et le joker dans forme à la fois décatique et binaire.",
            divPriklPodlTr : "Exemples d'adresses IP selon le schéma de classe (classfull)",
            btnTrA : "classe A",
            btnTrB : "classe B",
            btnTrC : "classe C",
            btnTrD : "classe D",
            btnTrE : "Classe E",
            divRiadCen : "Entrez l'adresse IP et la longueur du préfixe réseau",
            btnDecHosts : "réduire le nombre d'hôtes",
            btnIncHosts : "augmenter le nombre d'hôtes",
            h2VypSM : "Calcul du masque de réseau",
            btnSmWcDec : "forme décadaire",
            btnSmWcBin : "forme binaire",
            h2VypocetRozsahovSiete: "Calcul des plages réseau IP",
            h2VypocetMnozstvaIpAdries: "Calcul du nombre d'adresses IP",
            sm: "Masque de réseau",
            wc: "Wildcard",
            nwid: "Adresse réseau (ID)",
            rozsah : "Plage IP",
            lbc: "Locale broadcast",
            gw: "Adresse de passerelle recommandée",
            celkovoIp: "Total des adresses IP",
            pouzitelnychIp: "Adresses IP utilisables",
            pouzitelnychWoGw: "Adresses IP utilisables sans passerelle",
            percentIpKolaca: "Pourcentage du nombre total d'adresses IPv4",
        }
      },
    },    
  });

export default i18n;